import React, { useState } from 'react';
import { Modal, Button, List, Typography, Space } from 'antd';
import { EyeOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const AttachmentImageViewModal = ({ row, parentKey, title, status }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const attachments = row[parentKey] || [];

  const isImage = (fileName) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif','webp'];
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return imageExtensions.includes(fileExtension);
  };

  const handleDownload = (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Button
        onClick={showModal}
        disabled={!attachments.length || status === 1 || status === 2 || status === 3}
      >
        <EyeOutlined /> View Attachments
      </Button>
      <Modal
        title={`View Attachments - ${title}`}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        {attachments.length ? (
          <List
            itemLayout="vertical"
            dataSource={attachments}
            renderItem={(item) => (
              <List.Item>
                <Space direction="vertical" size="large">
                  {isImage(item.url) ? (
                    <img
                      width={400}
                      src={item.url}
                      alt={item.fileName}
                      style={{ marginBottom: '16px' }}
                    />
                  ) : (
                    <Text>{item.fileName}</Text>
                  )}
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() => handleDownload(item.url, item.fileName)}
                  >
                    Download
                  </Button>
                </Space>
              </List.Item>
            )}
          />
        ) : (
          <Text>No attachments to display</Text>
        )}
      </Modal>
    </>
  );
};

export default AttachmentImageViewModal;
